import React from 'react'
import { Space, Button, Typography, Flex } from 'antd'
import PropTypes from 'prop-types'
import { startRefinementProcess } from '../../../../../../../store/slices/rubric-refinement.slice'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { rubricRefinementSelectors } from '../../../../../../../store/selectors/rubricRefinement.selectors'
import { useLazyFetchRubricProgressQuery } from '../../../../../../../store/apis/rubric.api'
import { useParams } from 'react-router'
import { useVersionId } from '../../../../../../../utils/parseURL.helper'

const WelcomeMessage = () => {
    const hasStarted = useSelector(rubricRefinementSelectors.hasStarted)
    const dispatch = useDispatch()
    const { token, layerId: questionRubricId } = useParams()
    const versionId = useVersionId()

    const [fetchRubricProgress] = useLazyFetchRubricProgressQuery()

    const handleStart = () => {
        dispatch(startRefinementProcess())
        if (questionRubricId) {
            fetchRubricProgress({ questionRubricIds: [questionRubricId], token, versionId })
        }
    }

    return (
        <Space direction='vertical' size='large' style={{ width: '100%' }}>
            <Space align='center' size={16}>
                <span style={{ fontSize: '1.6rem' }}>👋</span>
                <Typography.Text type='secondary'>
                    <Typography.Text strong type='secondary'>
                        Welcome to the Rubric Refinement process!
                    </Typography.Text>{' '}
                    I will help you eliminate ambiguity and enhance clarity in your grading criteria—ensuring more
                    accurate AI-assisted assessment and a better experience for reviewers of student submissions.
                </Typography.Text>
            </Space>
            <Typography.Text type='secondary'>
                <Typography.Text strong type='secondary'>
                    Step 1: Compare two grading categories.
                </Typography.Text>{' '}
                You will see a student submission alongside two possible categories. I will explain and highlight why
                each one might apply.
            </Typography.Text>
            <Typography.Text type='secondary'>
                <Typography.Text strong type='secondary'>
                    Step 2: Choose the most fitting category.
                </Typography.Text>{' '}
                Based on the explanations, pick the category that best reflects the core of the submission.
            </Typography.Text>
            <Typography.Text type='secondary'>
                <Typography.Text strong type='secondary'>
                    Step 3: Review refinements.
                </Typography.Text>{' '}
                After making your choices, you will see suggested refinements aimed at removing ambiguity, improving
                clarity, and ensuring consistency between categories. You can either accept or reject these changes.
            </Typography.Text>
            <Typography.Text type='secondary'>
                Don't worry about losing progress - your work is automatically saved as you go. You can leave at any
                time and continue later right where you left off.
            </Typography.Text>
            {!hasStarted && (
                <Flex justify='center'>
                    <Button type='primary' size='large' onClick={handleStart} data-test='refinement-start-button'>
                        Let's get started
                    </Button>
                </Flex>
            )}
        </Space>
    )
}

WelcomeMessage.propTypes = {
    hasStarted: PropTypes.bool.isRequired,
    onStart: PropTypes.func.isRequired,
}

export default WelcomeMessage
